import script from "./TermsAndConditions.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsAndConditions.vue?vue&type=script&setup=true&lang=js"

import "./TermsAndConditions.vue?vue&type=style&index=0&id=c4a47e4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4a47e4e"]])

export default __exports__